import React from "react"
import { useSelector } from "react-redux"

import { VIEW, EDIT } from "const"
import { mtAccountsRoute, mtAccountRoute } from "client/parts/routes"
import { StoreType } from "client/store"
import { Switch, Route } from "client/components"

import List from "./list"
import View from "./view"
import Edit from "./edit"

const MtAccount = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    return userData.accountId === 1
        ? (
            <Switch>
                <Route
                    exact
                    path={mtAccountsRoute}
                    component={List}
                />
                <Route
                    path={`${mtAccountsRoute}/${VIEW}/:accountId`}
                    component={View}
                />
                <Route
                    path={`${mtAccountsRoute}/${EDIT}/:accountId`}
                    component={Edit}
                />
            </Switch>
        )
        : (
            <Switch>
                <Route
                    exact
                    path={`${mtAccountRoute}/${EDIT}`}
                    component={Edit}
                />
                <Route
                    path={mtAccountRoute}
                    component={View}
                />
            </Switch>
        )
}
export default MtAccount
